export interface ApiError {
  StatusCode: number;
  ErrorNumber: number;
  ErrorMessage: string;
}

export function isApiError<T>(res: T | ApiError): res is ApiError {
  return !!(res as ApiError)?.ErrorMessage;
}
